import { Col, Row } from "react-bootstrap";
import { useState, useRef, useEffect } from 'react';
import { Button, Input, Space, Table, Form, Popconfirm, Typography, InputNumber, Modal, Empty } from 'antd';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector, useDispatch } from 'react-redux'
import {
  getObjective, setMemberFail, getMemberFail, setMemberSuccess, getMemberSuccess, getBizID, getStyle, getFile, getFileID, getServices, getObjectiveCheck
} from '../../libs/todoSlice'
import LoadingComponent from "../../lib/LoadingComponent";
import axios from "axios";
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useNavigate, useParams } from 'react-router-dom';
import fontColor from "../../lib/fontColor";
import { getModalBeforeSuccessRedux, setModalBeforeSuccessRedux, getModalNoteRedux, setModalNoteRedux, getLoadingRedux, setLoadingRedux, getNoteTXTRedux, setNoteTXTRedux } from "../../libs/addFailSlice";
import Address from "../../lib/Address";
import { retryPreRegisterItems } from "../../lib/callAgainPreRegister";
import { resolveNoteText } from "../../lib/errorKeyNote";
import { buildCAPayload, buildCAFailResponse, CA_FAILURE_MESSAGE } from "../../lib/caPayload";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            // {
            //   required: true,
            //   message: `Please Input ${title}!`,
            // },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
//end function edit table

const AddFail = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const memberSuccess = useSelector(getMemberSuccess)
  const memberOneFail = useSelector(getMemberFail)
  const file = useSelector(getFile)
  const objective = useSelector(getObjective)
  const services = useSelector(getServices)
  const business_id = useSelector(getBizID)
  const style = useSelector(getStyle)
  const objectiveCheck = useSelector(getObjectiveCheck)

  const modalbeforeSuccess = useSelector(getModalBeforeSuccessRedux)
  const setModalBeforeSuccess = (action) => {
    dispatch(setModalBeforeSuccessRedux({
      modalbeforeSuccess: action
    }))
  }

  const modalNote = useSelector(getModalNoteRedux)
  const setModalNote = (action) => {
    dispatch(setModalNoteRedux({
      modalNote: action
    }))
  }

  const loading = useSelector(getLoadingRedux)
  const setLoading = (action) => {
    dispatch(setLoadingRedux({
      loading: action
    }))
  }

  const noteTXT = useSelector(getNoteTXTRedux)
  const setNoteTXT = (action) => {
    dispatch(setNoteTXTRedux({
      noteTXT: action
    }))
  }

  const alertManagement = () => {

    let message = `One ID`
    if (objective.includes('CA') || objective.includes('import-excel-rama')) {
      message += ', CA'
    }
    if (objective.includes('เลขที่หนังสือสัญญา')) {
      message += ' และเลขที่หนังสือสัญญา'
    }

    if (objective.includes('edu-student-pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับ นักเรียน/นักศึกษา'
    }

    if (objective.includes('edu-teacher-pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับ ครู/อาจารย์'
    }
    if (objective.includes('Pre-register')) {
      message = 'ข้อมูล Pre Registration สำหรับบุคคลากรทางการแพทย์'
    }

    if (memberSuccess.length !== 0) {
      return (
        <>
          สร้าง {message} แล้ว {memberSuccess.length} รายการ จาก {file.length} รายการ
        </>
      )
    } else {
      return (
        <>
          ไม่มีการสร้าง {message}
        </>
      )
    }

  }

  const handleRetry = async () => {
    const successResults = [];
    const failResults = [];
    setLoading(true);
    try {
      await retryPreRegisterItems({
        keys: stateBtnAgain,
        memberOneFail,
        objective,
        objectiveCheck,
        business_id,
        file_id: fileID,
        services,
        onItemStart: (key) =>
          setData((prev) =>
            prev.map((r) => ({ ...r, loading: r.key === key })),
          ),
        onItemSuccess: (_, result) => successResults.push(result),
        onItemFail: (_, result) => failResults.push(result),
      });

      const caFailResults = [];
      if (objective.includes('CA') || objective.includes('import-excel-rama')) {
        for (const result of successResults.filter((item) => !item.caRetry)) {
          if (!result.response?.data?.account_id) continue;

          try {
            await axios({
              method: 'POST',
              url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/ca`,
              data: buildCAPayload(result, business_id),
            });
          } catch (error) {
            caFailResults.push({
              request: result.request,
              response: buildCAFailResponse(error),
              retryType: 'ca',
              is_ca_fail: true,
              account_id: result.response.data.account_id,
              oneIdResponse: result.response,
            });
          }
        }
      }

      const caFailKeys = new Set(caFailResults.map((r) => r.request.key));
      const completedResults = successResults.filter((r) => !caFailKeys.has(r.request.key));
      const allFailResults = [...failResults, ...caFailResults];
      const okKeys = new Set(completedResults.map((r) => r.request.key));
      const failByKey = new Map(allFailResults.map((f) => [f.request.key, f]));
      const success_summary = [...memberSuccess, ...completedResults];
      const fail_summary = memberOneFail
        .filter((m) => !okKeys.has(m.request.key))
        .map((m) => failByKey.get(m.request.key) ?? m);

      dispatch(setMemberSuccess({ member_success: success_summary }));
      dispatch(setMemberFail({ member_fail: fail_summary }));
      await sendExcelSummary(success_summary, fail_summary);
      setStateBtnAgain([]);
      setModalBeforeSuccess(true);
    } finally {
      setData((prev) => prev.map((r) => ({ ...r, loading: false })));
      setLoading(false);
    }
  };
 
  useEffect(() => {
    let prepareData = memberOneFail.map((members, index) => {
      let title_en = members.request.title_en
      if (!members.request.title_en) {
        const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
        const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
        title_en = title_en_list[title_th_list.indexOf(members.request.title_th)]
      }
      return {
        key: members.request.key,
        loading: false,
        index: index,
        // index: members.request.index,
        contract_no: members.request.contract_no,
        employee_id: members.request.employee_id,
        title_th: members.request.title_th,
        title_en: title_en,
        name_th: members.request.name_th,
        surname_th: members.request.surname_th,
        name_eng: members.request.name_eng,
        surname_eng: members.request.surname_eng,
        cid: members.request.cid,
        address: members.request.address,
        tel: members.request.tel,
        mobile: members.request.mobile,
        email: members.request.email,
        biz_email: members.request.biz_email,
        position: members.request.position,
        department: members.request.department,
        sub_organization: members.request.sub_organization,
        organization: members.request.organization,
        tax_id: members.request.tax_id,
        maintainer_name_1: members.request.maintainer_name_1,
        maintainer_surname_1: members.request.maintainer_surname_1,
        maintainer_name_2: members.request.maintainer_name_2,
        maintainer_surname_2: members.request.maintainer_surname_2,
        maintainer_email_1: members.request.maintainer_email_1,
        maintainer_email_2: members.request.maintainer_email_2,
        maintainer_tel_1: members.request.maintainer_tel_1,
        maintainer_tel_2: members.request.maintainer_tel_2,
        maintainer_name_3: members.request.maintainer_name_3,
        maintainer_surname_3: members.request.maintainer_surname_3,
        maintainer_email_3: members.request.maintainer_email_3,
        maintainer_email_4: members.request.maintainer_email_4,
        maintainer_tel_3: members.request.maintainer_tel_3,
        maintainer_tel_4: members.request.maintainer_tel_4,
        id_card_type: members.request.id_card_type,
        response: members.response,
        room_no: members.request.room_no,
        house_no: members.request.house_no,
        moo: members.request.moo,
        floor: members.request.floor,
        street: members.request.street,
        building_name: members.request.building_name,
        alley: members.request.alley,
        start_year: members.request.start_year,
        end_year: members.request.end_year,
        status: members.request.status,
        student_id: members.request.student_id,
        username: members.request.username,
        password: members.request.password,
        faculty: members.request.faculty,
        sub_district: members.request.sub_district,
        district: members.request.district,
        zipcode: members.request.zipcode,
        province: members.request.province,
        nickname_th: members.request.nickname_th,
        nickname_eng: members.request.nickname_eng,
        birth_date: members.request.birth_date,
      }
    })
    setData(prepareData)
    setDataDefault(prepareData)
  }, [memberOneFail])
  // end function show member to fail table
  //function edit table
  const member_fail = useSelector(getMemberFail)
  useEffect(() => {
    setData(member_fail.map((member, index) => {
      return {
        ...member.request,
        index: index + 1,
        loading: false,
      }
    }))
  }, [member_fail]);

  const [form] = Form.useForm();
  const [data, setData] = useState([]);
  const [dataDefault, setDataDefault] = useState([]);
  const [editingKey, setEditingKey] = useState('');
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    form.setFieldsValue({
      index: '',
      contract_no: '',
      title_th: '',
      name_th: '',
      surname_th: '',
      name_eng: '',
      surname_eng: '',
      employee_id: '',
      biz_email: '',
      cid: '',
      address: '',
      // sub_district: '',
      // district: '',
      // province: '',
      // zipcode: '',
      tel: '',
      mobile: '',
      email: '',
      position: '',
      department: '',
      sub_organization: '',
      // organization:'',
      // tax_id:'',
      // maintainer_name_1:'',
      // maintainer_surname_1:'',
      // maintainer_name_2:'',
      // maintainer_surname_2:'',
      // maintainer_email_1:'',
      // maintainer_email_2:'',
      // maintainer_tel_1:'',
      // maintainer_tel_2:'',
      // name: '',
      // age: '',
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey('');
  };
  const save = async (key, not_set = false) => {
    setStateBtnAgain([])
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => {
        return key === item.index
      });
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        dispatch(setMemberFail({
          member_fail: memberOneFail.map((member, fail_index) => {
            return {
              ...member,
              request: fail_index === index ? newData[index] : member.request,
              response: member.response
            }
          })
        }))
        if (!not_set) {
          setEditingKey('');
        }
      } else {
        newData.push(row);
        setData(newData);
        if (!not_set) {
          setEditingKey('');
        }
      }
    } catch (errInfo) {
    }
  };

  const handleDelete = (key) => {
    setData((prev) => prev.filter((item) => item.key !== key));
    dispatch(setMemberFail({
      member_fail: memberOneFail.filter((m) => m.request.key !== key),
    }));
  };

  const columns = [
    {
      title: 'ลำดับที่',
      dataIndex: 'index',
      width: 100,
      show: true,
      fixed: 'left',
      render: (__, _, index) => __,
      // render: (__, _, index) => parseInt(index) + 1,
    },
    {
      title: 'เลขที่สัญญา',
      dataIndex: 'contract_no',
      width: 80,
      responsive: ['xs', 'sm'],
      editable: true,
      show: objective.includes('เลขที่หนังสือสัญญา'),
      fixed: 'left',
      // ...getColumnSearchProps('contract_no'),
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employee_id', //employee_id
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'คำนำหน้า',
      dataIndex: 'title_th',
      width: 150,
      show: true,
      // width: '10%',
      // editable: true,
      // ...getColumnSearchProps('title_th'),
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_th">คำนำหน้า</InputLabel>
            <Select
              value={record.title_th}
              labelId='title_th'
              label="คำนำหน้า"
              onChange={(e) => {
                let tempData = [...data]
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                const title_en = title_en_list[title_th_list.indexOf(e.target.value)]
                tempData[record.index - 1].title_th = e.target.value
                tempData[record.index - 1].title_en = title_en
                setData(tempData)
              }}
            >
              <MenuItem value={'นาย'}>นาย</MenuItem>
              <MenuItem value={'นางสาว'}>นางสาว</MenuItem>
              <MenuItem value={'นาง'}>นาง</MenuItem>
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'เด็กชาย'}>เด็กชาย</MenuItem>
                )
              }
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'เด็กหญิง'}>เด็กหญิง</MenuItem>
                )
              }

            </Select>
          </FormControl>
        ) : (record.title_th)
      }
    },
    {
      title: 'คำนำหน้า (ภาษาอังกฤษ)',
      dataIndex: 'title_en',
      width: 150,
      show: true,
      // width: '10%',
      // editable: true,
      // ...getColumnSearchProps('title_th'),
      render: (_, record, index) => {
        let show = ''
        if (!_) {
          let tempData = [...data]
          const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
          const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
          const title_en = title_en_list[title_th_list.indexOf(record.title_th)]
          show = title_en
        } else {
          show = _
        }
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_en">คำนำหน้า (ภาษาอังกฤษ)</InputLabel>
            <Select
              value={show}
              labelId='title_en'
              label="ภาษาอังกฤษ"
              onChange={(e) => {
                let tempData = [...data]
                const title_th_list = ['นาย', 'นาง', 'นางสาว', 'เด็กหญิง', 'เด็กชาย']
                const title_en_list = ['Mr', 'Mrs', 'Miss', 'Miss', 'Master']
                const title_th = title_th_list[title_en_list.indexOf(e.target.value)]
                tempData[record.index - 1].title_en = e.target.value
                tempData[record.index - 1].title_th = title_th
                setData(tempData)
              }}
            >
              <MenuItem value={'Mr'}>Mr</MenuItem>
              <MenuItem value={'Miss'}>Miss</MenuItem>
              <MenuItem value={'Mrs'}>Mrs</MenuItem>
              {
                objective.includes('edu-student-pre-register') && (
                  <MenuItem value={'Master'}>Master</MenuItem>
                )
              }
            </Select>
          </FormControl>
        ) : (show)
      }
    },
    {
      title: 'คำนำหน้านาม',
      dataIndex: 'title_special_th',
      width: 200,
      show: objective.includes('Pre-register'),
      // width: '10%',
      // editable: true,
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="title_special_th">คำนำหน้านาม</InputLabel>
            <Select
              value={record.title_special_th}
              labelId='title_special_th'
              label="คำนำหน้านาม"
              onChange={(e) => {
                record.title_special_th = e.target.value;
                save(record.index, true)
              }}
            >
              <MenuItem value={'นายแพทย์'}>นายแพทย์</MenuItem>
              <MenuItem value={'แพทย์หญิง'}>แพทย์หญิง</MenuItem>
              <MenuItem value={'ทันตแพทย์ชาย'}>ทันตแพทย์ชาย</MenuItem>
              <MenuItem value={'ทันตแพทย์หญิง'}>ทันตแพทย์หญิง</MenuItem>
              <MenuItem value={'เภสัชกรหญิง'}>เภสัชกรหญิง</MenuItem>
              <MenuItem value={'เภสัชกรชาย'}>เภสัชกรชาย</MenuItem>
            </Select>
          </FormControl>
        ) : (record.title_special_th)
      }
    },
    {
      title: 'เลขประจำตัวบุคลากรทางการแพทย์',
      dataIndex: 'employee_id',
      width: 180,
      editable: true,
      show: objective.includes('Pre-register'),

      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      width: 180,
      editable: true,
      show: objective.includes('Pre-register'),

      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คำนำหน้า อื่นๆ (ไทย)',
      dataIndex: 'special_title_th',
      width: 150,
      show: objective.includes('edu-teacher-pre-register') || objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'คำนำหน้า อื่นๆ (อังกฤษ)',
      dataIndex: 'special_title_eng',
      width: 150,
      show: objective.includes('edu-teacher-pre-register') || objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register') || (services.includes('one-id') || objectiveCheck.includes('ra') || services.includes('one-id-pmuc')),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },

    {
      title: 'ชื่อ (ภาษาไทย)',
      dataIndex: 'name_th',
      width: 150,
      show: true,
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ชื่อกลาง (ภาษาไทย)',
      dataIndex: 'middle_name_th',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'นามสกุล (ภาษาไทย)',
      dataIndex: 'surname_th',
      width: 150,
      show: true,
      // width: '10%',
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_th'),
    },
    {
      title: 'ชื่อ (ภาษาอังกฤษ)',
      dataIndex: 'name_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_eng'),
    },
    {
      title: 'ชื่อกลาง (ภาษาอังกฤษ)',
      dataIndex: 'middle_name_eng',
      width: 150,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-officer-pre-register'),
      // width: '10%',
      editable: true,
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'นามสกุล (ภาษาอังกฤษ)',
      dataIndex: 'surname_eng',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: 'ฉายา (ภาษาไทย)',
      dataIndex: 'nickname_th',
      width: 150,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: 'ฉายา (ภาษาอังกฤษ)',
      dataIndex: 'nickname_eng',
      width: 150,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('surname_eng'),
    },
    {
      title: 'ประเภทบัตร',
      dataIndex: 'id_card_type',
      width: 180,
      show: objective.includes('edu-student-pre-register') || objective.includes('edu-teacher-pre-register') || objective.includes('edu-officer-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="id_card_type">ประเภทบัตร</InputLabel>
            <Select
              value={record.id_card_type}
              labelId='id_card_type'
              label="ประเภทบัตร"
              onChange={(e) => {
                record.id_card_type = e.target.value;
                save(record.index, true)
              }}
            >
              <MenuItem value={'ID_CARD'}>ID_CARD</MenuItem>
              <MenuItem value={'PASSPORT'}>PASSPORT</MenuItem>
              {
                objective.includes('edu-student-pre-register') &&
                <MenuItem value={'G_CODE'}>G_CODE</MenuItem>

              }
            </Select>
          </FormControl>
        ) : (record.id_card_type)
      }
    },
    {
      title: 'เลขประจำตัวประชาชน',
      dataIndex: 'cid',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ระดับการศึกษา',
      dataIndex: 'degree',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'คณะ',
      dataIndex: 'faculty',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'Major (สาขา/ภาควิชา)',
      dataIndex: 'major',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'Minor (ถ้ามี)',
      dataIndex: 'minor',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'สถานะการศึกษา',
      dataIndex: 'status',
      width: 180,
      // editable: true,
      show: services.includes('edu-student-pre-register') && objective.includes('edu-student-pre-register'),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="status">คำนำหน้า</InputLabel>
            <Select
              value={record.status}
              labelId='status'
              label="คำนำหน้า"
              onChange={(e) => {
                record.status = e.target.value;
                save(record.index, true)
              }}
            >
              <MenuItem value={'กำลังศึกษา'}>กำลังศึกษา</MenuItem>
              <MenuItem value={'สำเร็จการศึกษา'}>สำเร็จการศึกษา</MenuItem>
              <MenuItem value={'ลาออก'}>ลาออก</MenuItem>
              <MenuItem value={'พ้นสภาพการศึกษา'}>พ้นสภาพการศึกษา</MenuItem>
              <MenuItem value={'อื่นๆ'}>อื่นๆ</MenuItem>
            </Select>
          </FormControl>
        ) : (record.status)
      }
    },
    {
      title: 'รหัสนักเรียน/บุคลากร ',
      dataIndex: 'student_id',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },

    {
      title: 'วันเกิด',
      dataIndex: 'birth_date',
      width: 150,
      editable: true,
      show: objective.includes('edu-student-pre-register') || objective.includes('Pre-register') || objective.includes('edu-officer-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'password',
      dataIndex: 'password',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },

    {
      title: 'ที่อยู่',
      dataIndex: 'address',
      width: 400,
      editable: true,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ที่อยู่ของหน่วยงาน',
      dataIndex: 'address',
      width: 400,
      editable: true,
      show: objective.includes('CA') || objective.includes('import-excel-rama') || objective.includes('contract-no') || objective.includes('เลขที่หนังสือสัญญา'),
      // show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('address'),
    },
    {
      title: 'ห้องที่',
      dataIndex: 'room_no',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'บ้านเลขที่',
      dataIndex: 'house_no',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'หมู่ที่',
      dataIndex: 'moo',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ชั้น',
      dataIndex: 'floor',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ถนน',
      dataIndex: 'street',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'อาคาร',
      dataIndex: 'building_name',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'หมู่บ้าน',
      dataIndex: 'alley',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'ตำบล',
      dataIndex: 'sub_district',
      width: 150,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="sub_district">ตำบล</InputLabel>
            <Select
              value={record.sub_district}
              labelId='sub_district'
              label="ตำบล"
              onChange={(e) => {
                let tempData = [...data]
                let index = null
                tempData.map((d, i) => {
                  if (d.index === record.index) {
                    index = i
                  }
                  return d
                })
                tempData[record.index - 1].sub_district = e.target.value
                setData(tempData)
              }}
            >
              {Address.getSubDistrict(record.province, record.district).map((sub_district, key) => {
                return <MenuItem key={key} value={sub_district}>{sub_district}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.sub_district)
      }
    },
    {
      title: 'อำเภอ',
      dataIndex: 'district',
      width: 150,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="district">อำเภอ</InputLabel>
            <Select
              value={record.district}
              labelId='district'
              label="อำเภอ"
              onChange={(e) => {
                let tempData = [...data]
                let index = null
                tempData.map((d, i) => {
                  if (d.index === record.index) {
                    index = i
                  }
                  return d
                })
                tempData[record.index - 1].district = e.target.value
                setData(tempData)
              }}
            >
              {Address.getDistrict(record.province).map((district, key) => {
                return <MenuItem key={key} value={district}>{district}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.district)
      }
    },
    {
      title: 'จังหวัด',
      dataIndex: 'province',
      width: 150,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="id_card_type">จังหวัด</InputLabel>
            <Select
              value={record.province}
              labelId='province'
              label="จังหวัด"
              onChange={(e) => {
                let tempData = [...data]
                let index = null
                tempData.map((d, i) => {
                  if (d.index === record.index) {
                    index = i
                  }
                  return d
                })
                tempData[record.index - 1].province = e.target.value
                setData(tempData)
              }}
            >
              {Address.getProvince().map((province, key) => {
                return <MenuItem key={key} value={province}>{province}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.province)
      }
    },
    {
      title: 'รหัสไปรษณีย์',
      dataIndex: 'zipcode',
      width: 150,
      show: objective.includes('edu-teacher-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      render: (_, record, index) => {
        const editable = isEditing(record);
        return editable ? (
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="zipcode">รหัสไปรษณีย์</InputLabel>
            <Select
              value={record.zipcode}
              labelId='zipcode'
              label="รหัสไปรษณีย์"
              onChange={(e) => {
                let tempData = [...data]
                let index = null
                tempData.map((d, i) => {
                  if (d.index === record.index) {
                    index = i
                  }
                  return d
                })
                tempData[record.index - 1].zipcode = e.target.value
                setData(tempData)
              }}
            >
              {Address.getZipCode(record.province, record.district, record.sub_district).map((zipcode, key) => {
                return <MenuItem key={key} value={zipcode}>{zipcode}</MenuItem>
              })}
            </Select>
          </FormControl>
        ) : (record.zipcode)
      }
    },
    {
      title: 'วันที่เริ่มการศึกษา',
      dataIndex: 'start_year',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'วันที่จบการศึกษา',
      dataIndex: 'end_year',
      width: 150,
      editable: true,
      // show: objective.includes('edu-student-pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('cid'),
    },
    {
      title: 'โทรศัพท์',
      dataIndex: 'tel',
      width: 150,
      editable: true,
      show: false,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('tel'),
    },
    {
      title: 'โทรศัพท์มือถือ',
      dataIndex: 'mobile',
      width: 150,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('mobile'),
    },
    {
      title: 'อีเมล',
      dataIndex: 'email',
      width: 250,
      editable: true,
      show: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('email'),
    },
    {
      title: 'อีเมลองค์กร',
      dataIndex: 'biz_email',
      width: 250,
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
    },
    {
      title: 'username',
      dataIndex: 'username',
      width: 180,
      editable: true,
      show: (services.includes('one-id') || objectiveCheck.includes('ra')),
      // fixed: 'left',
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('name_th'),
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 250,
      editable: true,
      show: objective.includes('Pre-register'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('email'),
    },
    {
      title: 'ตำแหน่งของเจ้าของใบรับรอง',
      dataIndex: 'position',
      width: 150,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      editable: true,
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('position'),
    },
    {
      title: 'ชื่อของหน่วยงานย่อยในองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'sub_organization',
      width: 250,
      editable: true,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
      // ...getColumnSearchProps('sub_organization'),
    },
    {
      title: 'ชื่อองค์กรที่เจ้าของใบรับรองสังกัด',
      dataIndex: 'organization',
      width: 350,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'เลขประจำตัวผู้เสียภาษีอากรของนิติบุคคล',
      dataIndex: 'tax_id',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
     {
      title: 'ชื่อคนที่ 3 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_3',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'ชื่อคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_name_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'นามสกุลคนที่ 4 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_surname_4',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'อีเมล 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_email_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 1 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_1',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'โทรศัพท์มือถือ 2 (ผู้ประสานงานและดูแลใบรับรองอิเล็กทรอนิกส์)',
      dataIndex: 'maintainer_tel_2',
      width: 200,
      show: (objective.includes('CA') || objective.includes('import-excel-rama')) && (params.prefix === "pmuc" || params.prefix === "pmub"),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],
    },
    {
      title: 'แผนก',
      dataIndex: 'department',
      editable: true,
      width: 120,
      show: services.includes('one-id') || objectiveCheck.includes('ra'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

    },
    {
      title: 'ตำแหน่ง',
      dataIndex: 'position',
      editable: true,
      width: 120,
      show: services.includes('one-id') || objectiveCheck.includes('ra'),
      responsive: ["xs", "sm", "md", "lg", "xl", "xxl"],

    },
    // {
    //   title: 'age',
    //   dataIndex: 'age',
    //   width: '15%',
    //   editable: true,
    // },
    {
      title: 'operation',
      dataIndex: 'operation',
      show: true,
      fixed: 'right',
      width: 200,
      render: (_, record, index) => {
        const editable = isEditing(record);
        return record.loading ? <LoadingComponent width={80} height={80} /> : editable ? (
          <span>
            <Button
              type='primary'
              disabled={loading}
              onClick={() => save(record.index)}
              style={{
                marginRight: 8,
                background: '#53BE35'
              }}
            >
              บันทึก
            </Button>
            <Popconfirm title="Sure to cancel?" disabled={loading} onConfirm={cancel}>
              ยกเลิก
            </Popconfirm>
          </span>
        ) : (
          <>
            <Typography.Link disabled={editingKey !== '' || loading} onClick={() => edit(record)}>
              <ModeEditOutlinedIcon style={{ color: '#053075' ?? style.primary_color, }} />
            </Typography.Link> &nbsp;
            {data.length >= 1 ? (
              <Popconfirm title="ต้องการลบข้อมูลนี้ใช่หรือไม่?"
                disabled={loading}
                // disabled
                onConfirm={() =>
                  handleDelete(record.key)
                }>
                <DeleteOutlinedIcon style={{ color: 'red', cursor: 'pointer' }} />
              </Popconfirm>
            ) : null
            }
            &nbsp;
            <Button size='large'
              disabled={loading}
              style={{ backgroundColor: '#F8F9FA', color: '#053075' }}
              onClick={() => {
                // หาด้วย key ไม่ใช้ index ของหน้า (antd ส่ง index แบบ relative ต่อหน้า)
                const failItem = memberOneFail.find(
                  (m) => m.request.key === record.key,
                );
                const notes = [].concat(
                  resolveNoteText(failItem?.response?.message),
                );
                setNoteTXT(
                  failItem?.is_ca_fail ? [CA_FAILURE_MESSAGE, ...notes] : notes,
                );
                setModalNote(true);
              }}>
              หมายเหตุ
            </Button>
          </>
        );
      },
    },
  ].filter(head => head.show);
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === 'age' ||
          col.dataIndex === 'index' ||
          col.dataIndex === 'no' ? 'number' : 'text',
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  // end edit table
  // start select row
  const [stateBtnAgain, setStateBtnAgain] = useState([]);
  const rowSelection = {
    selectedRowKeys: stateBtnAgain,
    onChange: (selectedRowKeys, selectedRows) => {
      setStateBtnAgain(selectedRowKeys)
    },
    getCheckboxProps: (selectedRowKeys) => {
      return {
        // Column configuration not to be checked
        key: selectedRowKeys.key,
        disabled: loading
      }
    }
    ,
  };
  // end select row
  // start search top

  // end searct top
  // function add fail or success to history
  const fileID = useSelector(getFileID)
  // const successList = useSelector(getMemberSuccess)
  // const params = useParams()
  // const failList = useSelector(getMemberFail)
  const sendExcelSummary = async (success, fail) => {
    let obj = [...objective]
    if (objectiveCheck.includes('ra') && !objective.includes('one-id-ra')) {
      obj = [...objective, 'one-id-ra']
    }
    try {
      await axios({
        method: 'PATCH',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/excel`,
        data: {
          _id: fileID,
          total: `${file.length}`,
          success: `${success.length}`,
          fail: `${fail.length}`,
          successDetail: success,
          objective: obj,
          objectiveCheck: objectiveCheck,
          failDetail: fail
        }
      })
      if (objectiveCheck.includes('ra')) {
        await sendEmailRA(business_id, fileID)
      }
    } catch (error) {
      console.error('Failed to save Excel summary:', error)
      if (error.response?.status === 401) {
        navigate(`/${params.prefix}`)
      }
    }
  }
  // end add data to history

  const sendEmailRA = async (biz_id, fileID) => {
    setLoading(true)
    try {
      await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/send-mail-oneid-ra?biz_id=${biz_id}&file_id=${fileID}`,
      })
    } catch (error) {
      console.error('Failed to send RA email:', error.response?.data ?? error.message)
    } finally {
      setLoading(false)
    }
  }

  const customLocale = {
    emptyText: (<Empty
      description="ไม่มีข้อมูล"
    />)
  };
  return (
    <>
      <Row>
        {/* <Col className="d-flex justify-content-start" xl={5} lg={6} md={6} sm={12} xs={12}>
          <Input.Group compact>
                <h5>ค้นหา</h5>
                <Input
                  value={searchParam}
                  allowClear
                  size="large"
                  style={{
                    width: 'calc(100% - 40px)',
                  }}
                  placeholder="ค้นหาด้วยชื่อ-นามสกุล(ภาษาไทย) หรือ เลขบัตรประจำตัวประชาชน"
                  onChange={({target}) => {
                    setSearchParam(target.value);
                  }}
                  onPressEnter={()=>{
                    searchName()
                  }}
                  maxLength={100}
                />
                <Button 
                icon={<SearchOutlined />} 
                size="large" 
                style={{borderRadius:'0px 4px 4px 0px'}}
                onClick={()=>{
                  searchName()
                }}
                />
              </Input.Group>
          </Col> */}
        <Col className="d-flex justify-content-end">
          {(stateBtnAgain.length !== 0) &&
            <>
              <Button
                style={{
                  borderColor: style.secondary_color ?? '#053075',
                  color: '#000000',
                  marginRight: '3px'
                }}
                onClick={() => {
                  let prepareData = data.filter(data => !stateBtnAgain.includes(data.key))
                  let prepareDataFail = member_fail.filter(data => !stateBtnAgain.includes(data.request.key))
                  setData(prepareData)
                  dispatch(setMemberFail({
                    member_fail: prepareDataFail
                  }))

                  setStateBtnAgain([])
                }}
              >
                ลบ
              </Button>

              <Button
                type="primary"
                style={{
                  background: style.secondary_color ?? '#053075',
                  color: style.secondary_color ? fontColor(style.secondary_color) : '#FFFFFF'
                }}
                disabled={loading}
                onClick={handleRetry}>
                <AutorenewIcon /> ดำเนินการสร้างอีกครั้ง
              </Button>
            </>
          }

        </Col>
      </Row>
      <Row style={{ marginTop: '20px' }}>
        {/* ui table */}
        <Form form={form} component={false}>
          <Table
            locale={customLocale}
            components={{
              body: {
                cell: EditableCell,
              },
            }}
            bordered
            dataSource={data}
            columns={mergedColumns}
            rowClassName="editable-row"
            pagination={{
              onChange: cancel,
            }}
            scroll={{
              x: 1400,
              y: 400,
            }}
            rowSelection={{
              type: 'checkbox',
              // ...rowSelection,
              ...rowSelection
            }}
          />
        </Form>
        {/* end ui table */}
      </Row>
      {/* modal หมายเหตุ */}
      <Modal
        title="หมายเหตุ"
        centered
        open={modalNote}
        footer={null}
        onCancel={() => setModalNote(false)}
      >
        <ul>
          {noteTXT.flat(Infinity).filter(Boolean).map((n, i) => (
            <li key={i}>{typeof n === 'string' ? n : JSON.stringify(n)}</li>
          ))}
        </ul>
      </Modal>
      {/* end modal หมายเหตุ */}
      {/* modal success */}
      <Modal
        title={memberSuccess.length !== 0 ? "ทำรายการสำเร็จ" : "ทำรายการไม่สำเร็จ"}
        centered
        open={modalbeforeSuccess}
        onOk={() => setModalBeforeSuccess(false)}
        onCancel={() => setModalBeforeSuccess(false)}
        footer={null}
      >
        <Row>
          <Col className='d-flex justify-content-center'>
            {memberSuccess.length !== 0 ?
              <CheckIcon style={{
                background: '#53BE35',
                borderRadius: '50%',
                fontSize: '50px',
                color: '#fff',
                padding: '10px'
              }} />
              :
              <CloseIcon style={{
                background: '#F37959',
                borderRadius: '50%',
                fontSize: '50px',
                color: '#fff',
                padding: '10px'
              }} />
            }
          </Col>
        </Row>
        <Row style={{ paddingTop: '30px', paddingBottom: '30px' }}>
          <Col className='d-flex justify-content-center'>
            {alertManagement()}
          </Col>
        </Row>
      </Modal>
    </>
  )
}
export default AddFail